import * as Yup from "yup";

export const smtpSettingsSchema = Yup.object({
  host: Yup.string().trim().required("SMTP host is required").max(255),
  port: Yup.string()
    .trim()
    .optional()
    .test("port", "Port must be between 1 and 65535", (v) => {
      if (v == null || v === "") return true;
      const n = Number(v);
      return Number.isInteger(n) && n >= 1 && n <= 65535;
    }),
  secure: Yup.boolean().required(),
  username: Yup.string().trim().max(255).optional(),
  fromEmail: Yup.string()
    .trim()
    .email("Enter a valid from email")
    .required("From email is required"),
  fromName: Yup.string().trim().max(255).optional(),
  password: Yup.string().optional(),
  clearStoredPassword: Yup.boolean().required(),
});

export default smtpSettingsSchema;
